import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { PageNotFound, type PageNotFoundProps } from '@openx/components-core/lib/PageNotFound/PageNotFound';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions';
import { PageHeader } from '@openx/components-header/PageHeader';
import { useTranslation } from 'react-i18next';
import { useProviderContext } from '../../utils/context/ProviderContext';
import { AllowedOrganizationsSection } from './sections/AllowedOrganizationsSection';
import { ProviderDetailsSection } from './sections/ProviderDetailsSection';

type ProviderDetailsPageProps = {
  handleGoBack: () => void;
  providerId: string;
  titlePrefix: PageNotFoundProps['appName'];
};

export const ProviderDetails = ({ handleGoBack, providerId, titlePrefix }: ProviderDetailsPageProps) => {
  const { t } = useTranslation();
  const { useProviderFetch, useProviderPageHeaderActions } = useProviderContext();
  const { provider, loading } = useProviderFetch(providerId);
  const actions = useProviderPageHeaderActions({ id: providerId, name: provider?.name });

  if (loading) return <Loader />;

  if (!provider || !providerId) {
    return <PageNotFound appName={titlePrefix} />;
  }

  return (
    <PageHeader
      goBack={handleGoBack}
      render={() => <HeaderActions actions={actions} />}
      title={t('Details: {name}', { name: provider.name })}
      titlePrefix={titlePrefix}
    >
      <ProviderDetailsSection provider={provider} />
      <AllowedOrganizationsSection allowedAccounts={provider.allowed_accounts} />
    </PageHeader>
  );
};
